import React from 'react';
import type { InitialState } from './AppConfig';
import { AppConfigContext } from './AppConfig';
import { Suggestions } from './suggest/Suggestions';

type AppProps = InitialState;

export function App(props: AppProps) {
    const { isProbablyMobile, searchPlaceholder, searchTerm, ...appConfig } =
        props;

    return (
        <AppConfigContext.Provider value={appConfig}>
            <Suggestions
                isProbablyMobile={isProbablyMobile}
                searchPlaceholder={searchPlaceholder}
                searchTerm={searchTerm}
            />
        </AppConfigContext.Provider>
    );
}
